/*
 * @Author: 李明明
 * @Date: 2022-03-07 15:11:02
 * @LastEditTime: 2022-09-19 09:30:47
 * @LastEditors: 李明明
 * @Description: 公共过滤器
 * @FilePath: /ykt-micro-main/src/utils/filter.js
 * 代码版权方：'政府采购信息网'
 */
import { ElMessage } from "element-plus";

/**
 * @description: 匹配手机号隐藏
 * @param {
 *  value: 原始手机号
 * }
 * @return {
 *  130****0000
 * }
 */
const phoneFilter = (value) => {
  if (!value) return "";
  let str = value;
  str = str.toString().replace(/^(\d{3})(\d{4})(\d{4})/g, "$1****$3");
  return str;
};

/**
 * @description: 匹配身份证号隐藏
 * @param {*} value
 * @return {*}
 */
const identFilter = (value) => {
  if (!value) return "";
  let str = value;
  str = str.toString().replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2");
  return str;
};

//保留2位小数点过滤器 不四舍五入
const moneyFilter = (value) => {
  var toFixedNum = Number(value).toFixed(3);
  var realVal = toFixedNum.substring(0, toFixedNum.toString().length - 1);
  return realVal;
};

const changeMoney = function (num) {
  // 数组求和
  function sum(arr) {
    return arr.reduce(function (prev, curr) {
      return prev + curr;
    });
  }

  if (typeof num == "object") {
    num = (sum(num) / 100).toFixed(2);
    num = num.replace(regexp, "$1");
  } else {
    var regexp = /(?:\.0*|(\.\d+?)0+)$/;
    num = (num / 100).toFixed(2);
    num = num.replace(regexp, "$1");
  }

  var toFixedNum = Number(num).toFixed(3);
  var realVal = toFixedNum.substring(0, toFixedNum.toString().length - 1);

  return realVal;
};

// 点击复制
const copyText = function (el) {
  console.log(el);
  var input = document.getElementById("input");
  input.value = el; // 修改文本框的内容
  input.select(); // 选中文本
  document.execCommand("copy"); // 执行浏览器复制命令
  ElMessage.success("复制成功");
};

// 数组求和
const sum = function (arr) {
  return arr.reduce(function (prev, curr) {
    return prev + curr;
  });
};

// 抓取文章内容
const getBody = function (content) {
  var REG_BODY = /<body[^>]*>([\s\S]*)<\/body>/;
  var result = REG_BODY.exec(content);
  if (result && result.length === 2) return result[1];
  return content;
};

// 秒转时间
const dateFormat = function (second, type) {
  var dd, hh, mm, ss;
  second = typeof second === "string" ? parseInt(second) : second;
  if (!second || second < 0) {
    return;
  }
  if ((type == 2) | (type == 4)) {
    //小时
    hh = (second / 3600) | 0;
    second = Math.round(second) - hh * 3600;
  }
  //分
  mm = (second / 60) | 0;
  //秒
  ss = Math.round(second) - mm * 60;
  if (Math.round(dd) < 10) {
    dd = dd > 0 ? "0" + dd : "";
  }
  if (Math.round(hh) < 10) {
    hh = "0" + hh;
  }
  if (Math.round(mm) < 10) {
    mm = "0" + mm;
  }
  if (Math.round(ss) < 10) {
    ss = "0" + ss;
  }
  if (type == "1") {
    return mm + "'" + ss + "''";
  } else if (type == "2") {
    return hh + "小时" + mm + "分钟";
  } else if (type == "3") {
    return mm + ":" + ss;
  } else if (type == "4") {
    return hh + ":" + mm;
  }
};

const dateFormat2 = function (second, type) {
  var dd, hh, mm, ss;
  second = typeof second === "string" ? parseInt(second) : second;
  if (!second || second < 0) {
    return;
  }
  if ((type == 2) | (type == 4)) {
    //小时
    hh = (second / 3600) | 0;
    second = Math.round(second) - hh * 3600;
  }
  //分
  mm = (second / 60) | 0;
  //秒
  ss = Math.round(second) - mm * 60;
  if (Math.round(dd) < 10) {
    dd = dd > 0 ? "0" + dd : "";
  }
  if (Math.round(hh) < 10) {
    hh = "0" + hh;
  }
  if (Math.round(mm) < 10) {
    mm = "0" + mm;
  }
  if (Math.round(ss) < 10) {
    ss = "0" + ss;
  }
  if (type == "1") {
    return mm + "'" + ss + "''";
  } else if (type == "2") {
    return `
      <span class="time">${hh}</span>
                <span class="time_txt">小时</span>
                <span class="time" style="margin-left: 10px">${mm}</span>
                <span class="time_txt">分钟</span>
    `;
  } else if (type == "3") {
    return mm + ":" + ss;
  } else if (type == "4") {
    return hh + ":" + mm;
  }
};

export {
  phoneFilter,
  identFilter,
  moneyFilter,
  changeMoney,
  copyText,
  sum,
  getBody,
  dateFormat,
  dateFormat2,
};
